import { render, staticRenderFns } from "./huodongdengji.vue?vue&type=template&id=360cab17&scoped=true"
import script from "./huodongdengji.vue?vue&type=script&lang=js"
export * from "./huodongdengji.vue?vue&type=script&lang=js"
import style0 from "./huodongdengji.vue?vue&type=style&index=0&id=360cab17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360cab17",
  null
  
)

export default component.exports